'use strict';

(function () {
  angular
    .module('specsguardApp')
    .directive('widgetProjectAreas', widgetProjectAreas);

  function widgetProjectAreas () {
    return {
      restrict: 'E',
      templateUrl: 'app-legacy/project/overview/widgets/areas/widget-project-areas.tmpl.html',
      controller: 'widgetProjectAreas',
      controllerAs: '$widgetProjectAreas',
      scope: true,
    };
  }
})();
